import type { OfferType, PersonAdditionalData, Vehicle } from "."
import type { Risk } from "../enums"
import type { DiscountRequestState } from "../enums/DiscountRequestState"

export type InsurerDiscount = {
  insurerId: number
  insurerName: string
  discounts: Discount[]
}

export type Discount = {
  insuranceCategoryDiscountId: number
  insuranceCategoryDiscount: InsuranceCategoryDiscount
  discount?: number | null
  unit: string
  type: DiscountType | null
  specificRiskType: Risk | null
  valid: boolean
  minDiscount: number
  maxDiscount: number
  name: string
  description: string
  group: number
  editK1: boolean
  editK2: boolean
  showK2: boolean
  voucher: string
}

export type AvailableDiscounts = {
  availableDiscounts: Discount[]
  discountRequest?: DiscountRequest
}

export type DiscountRequest = {
  state: DiscountRequestState
  text?: string
  answer?: string
  userCanApprove: boolean
  discounts: DiscountRequestDiscount[]
}

export type DiscountRequestDiscount = {
  requestedValue: number
  newValue: number
  requestedInsuranceCategoryDiscountId: number
  approvedInsuranceCategoryDiscountId: number
  name: string
  unit: string
}

export type OfferDiscounts = {
  discounts?: Discount[] // pokud je zde discounts?: Discount[], tak padá kompilace v containers/offers/tabs/carkulka/DiscountTab.tsx
  individualDiscount?: IndividualDiscount
}

export const DiscountType = {
  BusinessDiscount1: 1,
  BusinessDiscount2: 2,
  BusinessDiscount3: 3,
  PovDiscount: 6,
  HavDiscount: 7,
  ContractDiscount1: 8,
  ContractDiscount2: 9,
  ContractDiscount3: 10,
  MarketingActionPov: 11,
  MarketingActionHav: 12,
  Special: 13,
  ContractDiscount4: 14,
  Voucher: 15,
  Coupon: 16,
  MarketingActionProperty: 17,
  VoucherPov: 18,
  VoucherHav: 19
} as const;

export const getGcpVoucherName = (type: DiscountType | null) => {
  switch (type) {
    case DiscountType.Voucher:
      return 'Kód voucheru (smlouvy)'
    case DiscountType.VoucherPov:
      return 'Kód voucheru (POV)'
    case DiscountType.VoucherHav:
      return 'Kód voucheru (HAV)'
    default:
      return ''
  }
}

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];

export const DiscountUnits = {
  Percentage: 0,
  Czk: 1,
} as const;
export type DiscountUnits = typeof DiscountUnits[keyof typeof DiscountUnits];

export const DiscountBehaviorTypes = {
  EditK1: 1,
  EditK2: 2,
  ShowK2: 3,
}
export type DiscountBehaviorTypes = typeof DiscountBehaviorTypes[keyof typeof DiscountBehaviorTypes];

export type IndividualDiscount = {
  insurer: number
}

export type InsuranceCategoryDiscount = {
  id: number
  insuranceCategoryInsurerId: number
  discountType: DiscountType
  keyName: string
  maxDiscount: number
  minDiscount: number
  unit: string
  unitEnum: DiscountUnits
  group: number
  name: string
  code: string
  specificRisk: Risk | null
  validFrom: string | null
  validTo: string | null
  valid: boolean
  isValidNow: boolean
  deleted: boolean
  behavior: DiscountBehaviorTypes[]
  conflictDiscountsIds: number[]
}

export interface WaitingDiscountRequests {
  totalCount: number
  items: WaitingDiscountRequest[]
}

export interface WaitingDiscountRequest {
  paramsId: number
  insuranceStartDate: Date
  dateCreated: Date
  step: number
  offerId: number
  offerType: OfferType
  insurerId: number
  insurerName: string
  requested: Date
  requestedById: string
  requestedByLastName: string
  requestedByFirstName: string
  discounts: RequestDiscount[]
  policyHolder?: PersonAdditionalData
}

export interface WaitingDiscountRequestVehicle extends WaitingDiscountRequest {
  vehicle?: Vehicle
}

export interface RequestDiscount {
  name: string
  requestedValue: number
}